import { usersApi } from 'entities/users';
import { toast } from 'react-toastify';

const useBrands = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getBrands: builder.query({
      query: ({ app_type, page, size }) => ({ url: '/news-pages/admin/brands', params: { app_type, page, size } }),
    }),

    getBrand: builder.query({
      query: ({ id, language_id }) => ({ url: `/news-pages/admin/brand/${id}`, params: { language_id } }),
    }),

    addBrand: builder.mutation({
      query: ({ body }) => ({
        url: '/news-pages/admin/brand',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно добавили бренд', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),

    editBrand: builder.mutation({
      query: ({ id, body }) => ({
        url: `/news-pages/admin/brand/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно изменили бренд', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),

    deleteBrand: builder.mutation({
      query: ({ id }: { id: number }) => ({
        url: `/news-pages/admin/brand/${id}`,
        method: 'DELETE',
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили бренд', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
  }),
});

export const {
  useGetBrandsQuery,
  useGetBrandQuery,
  useAddBrandMutation,
  useEditBrandMutation,
  useDeleteBrandMutation,
} = useBrands;
